import { __awaiter, __generator } from "tslib";
import { fetchSFCCSetting } from '@gn-audio/core/api/site-settings';
import { fetchEcomSetting } from '@gn-audio/core/api/site-settings/fetch-ecom-setting';
import { fetchSiteFeatures } from '@gn-audio/core/api/site-settings/fetch-site-features';
/**
 * Checks whether SFCC basket could be bootstrapped on current web site.
 */
export var canBootstrapSFCCBasket = function () { return __awaiter(void 0, void 0, void 0, function () {
    var ecomSetting, sfccBasketFeatures, sfccSetting;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchEcomSetting()];
            case 1:
                ecomSetting = _a.sent();
                if (!(ecomSetting === null || ecomSetting === void 0 ? void 0 : ecomSetting.ecomEnabled)) {
                    return [2 /*return*/, false];
                }
                return [4 /*yield*/, fetchSiteFeatures(["SfccBasket" /* SiteFeature.SfccBasket */])];
            case 2:
                sfccBasketFeatures = _a.sent();
                if (sfccBasketFeatures.length === 0 || !sfccBasketFeatures[0].value) {
                    return [2 /*return*/, false];
                }
                return [4 /*yield*/, fetchSFCCSetting()];
            case 3:
                sfccSetting = _a.sent();
                if (!(sfccSetting === null || sfccSetting === void 0 ? void 0 : sfccSetting.currency)) {
                    return [2 /*return*/, false];
                }
                return [2 /*return*/, true];
        }
    });
}); };
